const SET_PHOTO_CAPTURE_SMART_SKIN_SCAN_CONTENT = 'SET_PHOTO_CAPTURE_SMART_SKIN_SCAN_CONTENT';

export { SET_PHOTO_CAPTURE_SMART_SKIN_SCAN_CONTENT };
